<script>
import entry from '../../entry';
import _ from './_.vue';

const components = { _ };
const map = {
  4: '_'
};

export default entry({
  name: 'subscription-entry',
  components,
  map
});
</script>
